import { BlankState } from '@domain-group/suit-theme'

import blankStateImage from './assets/user-tiles.svg'

interface UsersBlankStateProps {
  title?: string,
}

const UsersBlankState = (props: UsersBlankStateProps) => {
  const { title = 'No Users' } = props

  return (
    <BlankState boxProps={{ border: 'none' }} imageUrl={blankStateImage}>
      {/*
       // @ts-expect-error TS2339 */}
      <BlankState.Title>{title}</BlankState.Title>

      {/*
       // @ts-expect-error TS2339 */}
      <BlankState.Paragraph>Try adjusting your filters to return more results.</BlankState.Paragraph>
    </BlankState>
  )
}
export default UsersBlankState
